// depricated 28.12.16  transfer to app
// /var phone = $("input.phone").val();
//if(phone != ""){
//    getPhoneInfo(phone);
//}

function bartCountChars(id,charsCounterId,msgid){
    var text = $("#"+id).val();
    var charsCounter = text.length;
    var smsCount = Math.ceil(charsCounter / 70);
    $("#"+charsCounterId).html(charsCounter);
    $("#"+msgid).html(smsCount);
}

function getPhoneInfo(phone){
    $.ajax({
        type: "GET",
        url: '/phone',
        data: {"phone": phone},
        success: function (data) {
            var info = "";
            if(data.users && data.users[0]){
                info += 'Пользователь:<br>';
                for(user_id in data.users){
                    var user = data.users[user_id];
                    info += "<a href='/users/"+user.user_id+"'>"+user.l_name+" "+user.f_name+" "+user.m_name+"</a><br>";
                }

            }

            if(data.orders && data.orders[0]){
                info += '<br>Заказы:<br>';
                for(order_id in data.orders){
                    var order = data.orders[order_id];
                    info += "№<a href='/orders/"+order.order_id+"'>"+order.order_id+"</a>&nbsp;";
                }

            }
            $(".information").html(info);
        },
        error: function(data){
            var info = "<div class='alert alert-danger'>"+data+"</div>";
            $(".information").html(info);
        }
    });
}
